export default function ImportIcon() {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_40225_98005'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='20'
        height='20'
      >
        <rect width='20' height='20' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_40225_98005)'>
        <path
          d='M10.0025 1.66589C11.1541 1.66589 12.2368 1.8849 13.2506 2.32291C14.2645 2.76093 15.1465 3.35502 15.8967 4.10517C16.6468 4.85533 17.2409 5.73736 17.6789 6.75126C18.1169 7.76502 18.3359 8.84771 18.3359 9.99933C18.3359 11.8448 17.79 13.5022 16.698 14.9715C15.6059 16.4409 14.1781 17.4437 12.4148 17.9801L12.4148 16.5665C13.8015 16.0594 14.9157 15.2074 15.7574 14.0108C16.5992 12.8143 17.0201 11.4771 17.0201 9.99933C17.0201 8.04024 16.3403 6.38086 14.9806 5.02119C13.621 3.66153 11.9616 2.98169 10.0025 2.98169C8.04341 2.98169 6.38403 3.66153 5.02436 5.02119C3.66469 6.38086 2.98486 8.04024 2.98486 9.99933C2.98486 11.4771 3.40577 12.8143 4.2476 14.0108C5.08927 15.2074 6.20347 16.0593 7.59018 16.5665L7.59018 17.9801C5.82686 17.4437 4.39913 16.4409 3.30701 14.9715C2.21504 13.5022 1.66905 11.8448 1.66905 9.99933C1.66905 8.84771 1.88806 7.76502 2.32608 6.75126C2.7641 5.73736 3.35818 4.85533 4.10834 4.10517C4.8585 3.35502 5.74053 2.76093 6.75443 2.32291C7.76818 1.8849 8.85087 1.66589 10.0025 1.66589ZM10.0025 6.80258L14.0848 10.8849L13.1604 11.8094L10.6604 9.32278L10.6604 18.3242L9.34459 18.3242L9.34459 9.32278L6.84456 11.8094L5.92021 10.8849L10.0025 6.80258Z'
          fill='#777777'
        />
      </g>
    </svg>
  );
}
